const imageBrandPath = `https://resources.wowcher.co.uk/brand-assets/${process.env.NEXT_PUBLIC_BRAND_FRONTEND}`;
const imageCommonPath = `https://resources.wowcher.co.uk/brand-assets/common`;

/* NEW IMAGE PATHS */
export const FAVICON = `${imageBrandPath}/favicon.ico`;
export const BACK_LOGO = `${imageBrandPath}/back.svg`;

export const SPLAT = `${imageBrandPath}/splat.svg`;

export const GOOGLE_IMG = `${imageCommonPath}/google-icon.svg`;

export const VIP_IMG = `${imageBrandPath}/logos/vip.svg`;

export const MYACCOUNT_LOGO_MOBILE = `${imageBrandPath}/mobile-burger-menu.svg`;

export const MYACCOUNT_LOGO_NORTON = '/assets/img/norton_seal.png'; // not getting used anywhere
export const APPLE_APP_STORE_LOGO = `${imageCommonPath}/apple-store-icon.svg`;
export const GOOGLE_PLAY_LOGO = `${imageCommonPath}/google-store-icon.svg`;
export const CAREERS_IMG = `${imageCommonPath}/careers.png`;

export const PLACEHOLDER_IMG = `${imageBrandPath}/not-found.jpg`;

export const PLACEHOLDER_IMG_ALT = 'No image found';

export const CLAIM_GIFT_IMG = `${imageBrandPath}/gift-redeem.webp`;

export const NORTON_SEAL = `${imageCommonPath}/norton-seal.png`;

export const CYF_BANNER =
  'https://images.wowcher.co.uk/binaries/choose-your-flight-desktop-2-wowcher.jpg';

export const CYF_BANNER_MOBILE =
  'https://images.wowcher.co.uk/binaries/choose-your-flight-mobile-2-wowcher.jpg';

// APP BANNER
export const APP_BANNER_ICON =
  'https://resources.wowcher.co.uk/images/Icon-App-60x60@1x.png';

export const GIFT_CARD_IMG = `${imageBrandPath}/gift-card.png`;

export const GIFT_ICON_IMG = `${imageBrandPath}/gift-icon.svg`;

export const SUBSCRIBE_IMG =
  'https://resources.wowcher.co.uk/images/subscription-bg_m.jpg';

// WALLET
export const WALLET_HISTORY_HEADER = `${imageCommonPath}/wallet-history-header.png`;
export const WALLET_HISTORY_CHIP = `${imageCommonPath}/wallet-history-chip.png`;

// CHECKOUT
export const GIFT_PACK_INFO_IMG =
  'https://resources.wowcher.co.uk/assets/img/giftcard_info.png';

export const GIFT_WRAP_INFO_IMG = `${imageCommonPath}/gift-wrap-info-image.jpg`;
export const EGIFT_INFO_IMG = `${imageBrandPath}/egift-info-image.jpg`;
export const WALLET_IMG = `${imageBrandPath}/wallet-image.png`;
export const CARD_BUTTON_IMG = `${imageCommonPath}/pay-card-image.svg`;

export const PAYPAL_BUTTON_IMG = `${imageCommonPath}/paypal-button.svg`;

export const GOOGLE_BUTTON_IMG = `${imageCommonPath}/google-pay-button.svg`;

export const APPLE_BUTTON_IMG = `${imageCommonPath}/apple-pay-button.svg`;

export const BUTTON_IMG_GOOGLE_PAY = `${imageCommonPath}/google-pay-button-white.svg`;
export const BUTTON_IMG_APPLE_PAY = `${imageCommonPath}/apple-pay-button-white.svg`;

export const CLEARPAY_BUTTON_IMG = `${imageCommonPath}/clearpay-badge.svg`;

export const KLARNA_BUTTON_IMG = `${imageCommonPath}/klarna-badge.svg`;

export const KLARNA_LOGO =
  'https://resources.wowcher.co.uk/assets/img/klarna-modal-title.svg';
export const KLARNA_MARKETING_BADGE =
  'https://resources.wowcher.co.uk/assets/img/klarna-marketing-badge.svg';

export const ATOL_LOGO = `${imageCommonPath}/atol-logo.svg`;

// VIP
export const CROWN_ICON = `${imageBrandPath}/crown-image.svg`;

export const TAG_ICON = `${imageBrandPath}/tag-icon.svg`;

export const TROPHY_ICON = `${imageBrandPath}/trophy-icon.svg`;

export const PAYPAL_CREDIT = `${imageCommonPath}/paypal-credit-logo.svg`;
export const IMG_INVASIVEHEALTH_THEREISNOHURRY = `${imageBrandPath}/calender.svg`;
export const IMG_INVASIVEHEALTH_TIMETOTHINK = `${imageBrandPath}/question-mark.svg`;
export const IMG_INVASIVEHEALTH_SAFEHANDS = `${imageBrandPath}/hands-with-a-heart-image.png`;
export const IMG_INVASIVEHEALTH_NOTSURE = `${imageBrandPath}/thought-bubble-image.svg`;

export const OPEN_POP_UP_IMAGE = `${imageCommonPath}/open-pop-up-icon.svg`;
export const LIGHT_BOX_MODAL = {
  brands: {
    fivepm: {
      background: {
        popeye: 'https://resources.wowcher.co.uk/images/subscription-bg-v2.jpg',
        subscribe: SUBSCRIBE_IMG,
      },
    },
    livingSocial: {
      background: {
        popeye:
          'https://resources.wowcher.co.uk/images/ls/subscription-bg-v2.jpg',
        subscribe: SUBSCRIBE_IMG,
      },
    },
    vip: {
      background: {
        popeye:
          'https://resources.wowcher.co.uk/images/subscriptionImage_t3-v2.jpg',
        subscribe: SUBSCRIBE_IMG,
      },
    },
    wowcher: {
      background: {
        popeye: 'https://resources.wowcher.co.uk/images/subscription-bg-v2.jpg',
        subscribe: SUBSCRIBE_IMG,
      },
    },
  },
};

const ERROR_404_PLACEHOLDER =
  'https://resources.wowcher.co.uk/images/404-bg.png';
export const ERROR_TYPES = {
  brands: {
    fivepm: {
      404: ERROR_404_PLACEHOLDER,
    },
    livingSocial: {
      404: ERROR_404_PLACEHOLDER,
    },
    vip: {
      404: ERROR_404_PLACEHOLDER,
    },
    wowcher: {
      404: ERROR_404_PLACEHOLDER,
    },
  },
};

export const FLAGS = {
  ireland: 'https://resources.wowcher.co.uk/images/ls/IE_flag.jpg',
  unitedKingdom: 'https://resources.wowcher.co.uk/images/ls/UK_flag.jpg',
};

export const TRIP_ADVISOR = `${imageCommonPath}/trip-advisor-logo.png`;
export const REVIEWS_IO = `${imageCommonPath}/reviews-io-logo.svg`;

export const GIFT_RECIPIENT_ONE = `${imageBrandPath}/husband-image.svg`;
export const GIFT_RECIPIENT_TWO = `${imageBrandPath}/wife-image.svg`;
export const GIFT_RECIPIENT_THREE = `${imageBrandPath}/girl-image.svg`;
export const GIFT_RECIPIENT_FOUR = `${imageBrandPath}/teen-image.svg`;
export const GIFT_RECIPIENT_FIVE = `${imageBrandPath}/best-friends-image.svg`;
export const GIFT_RECIPIENT_SIX = `${imageBrandPath}/colleague-image.svg`;
export const GIFT_RECIPIENT_SEVEN = `${imageBrandPath}/mother-image.svg`;
export const GIFT_RECIPIENT_EIGHT = `${imageBrandPath}/father-image.svg`;
export const GIFT_RECIPIENT_NINE = `${imageBrandPath}/grandparents-image.svg`;
export const GIFT_RECIPIENT_TEN = `${imageBrandPath}/valentines-image.svg`;

export const GIFT_PERSONALITY_ONE = `${imageBrandPath}/personality-playful.svg`;
export const GIFT_PERSONALITY_TWO = `${imageBrandPath}/personality-insta-famous.svg`;
export const GIFT_PERSONALITY_THREE = `${imageBrandPath}/personality-geeky.svg`;
export const GIFT_PERSONALITY_FOUR = `${imageBrandPath}/personality-giggly.svg`;
export const GIFT_PERSONALITY_FIVE = `${imageBrandPath}/personality-gorgeous.svg`;
export const GIFT_PERSONALITY_SIX = `${imageBrandPath}/personality-fit.svg`;
export const GIFT_PERSONALITY_SEVEN = `${imageBrandPath}/personality-pampered.svg`;
export const GIFT_PERSONALITY_EIGHT = `${imageBrandPath}/personality-jetsetter.svg`;
export const GIFT_PERSONALITY_NINE = `${imageBrandPath}/personality-daredevil.svg`;
export const GIFT_PERSONALITY_TEN = `${imageBrandPath}/personality-indulgent.svg`;

export const GIFT_BANNER = {
  fivepm:
    'https://resources.wowcher.co.uk/assets/img/brand/wowcher/gift/banner/mothers-day-desktop_v2.svg',
  'living-social':
    'https://resources.wowcher.co.uk/assets/img/brand/living-social/gift/banner/mothers-day-desktop_v1.svg',
  wowcher:
    'https://resources.wowcher.co.uk/assets/img/brand/wowcher/gift/banner/mothers-day-desktop_v2.svg',
};
export const GIFT_BANNER_MOBILE = {
  fivepm:
    'https://resources.wowcher.co.uk/assets/img/brand/wowcher/gift/banner/mothers-day-mobile_v2.svg',
  'living-social':
    'https://resources.wowcher.co.uk/assets/img/brand/living-social/gift/banner/mothers-day-mobile_v1.svg',
  wowcher:
    'https://resources.wowcher.co.uk/assets/img/brand/wowcher/gift/banner/mothers-day-mobile_v2.svg',
};
export const PAYPAL_CREDIT_OVERLAY =
  'https://static.wowcher.co.uk/binaries/Eligible-for-Paypal-Credit-New.png';

export const PAYPAL_CREDIT_OVERLAY_TRAVEL =
  'https://static.wowcher.co.uk/binaries/PayPal-and-Travel-Spacing-WOW.png';

// Redeem In App info

export const REDEEM_INFO_DESKTOP = `${imageBrandPath}/redeem-desktop.png`;

export const REDEEM_INFO_MOBILE = `${imageBrandPath}/redeem-mobile.png`;

// export const REDEEM_LS_INFO =
//   'http://resources.wowcher.co.uk/assets/img/brand/living-social/redeem/Redeem-desktop.jpeg';

// export const REDEEM_LS_INFO_MOBILE =
//   'http://resources.wowcher.co.uk/assets/img/brand/living-social/redeem/Redeem-mobile.jpeg';

// QR codes for redeem in app

export const REDEEM_WOWCHER_QR_CODE_DEV =
  'https://resources.wowcher.co.uk/assets/img/wowcher-redeem-in-app-dev-nxt.svg';

export const REDEEM_WOWCHER_QR_CODE_PROD =
  'https://resources.wowcher.co.uk/assets/img/wowcher-redeem-in-app-prod.svg';

export const REDEEM_LS_QR_CODE_DEV =
  'https://resources.wowcher.co.uk/assets/img/ls-redeem-in-app-dev-nxt.svg';

export const REDEEM_LS_QR_CODE_PROD =
  'https://resources.wowcher.co.uk/assets/img/ls-redeem-in-app-prod.svg';

export const PINK_GIFT = `${imageCommonPath}/pink-gift.png`;

export const GIFT_FINDER_BANNER_MOBILE =
  'https://resources.wowcher.co.uk/assets/img/brand/wowcher/gift/banner/gifts-mobile-banner.png';

// Wowcher VIP Logo
export const VIP_LOGO = `${imageBrandPath}/logos/vip.svg`;
export const VIP_LOGO_WHITE = `${imageBrandPath}/logos/vip-logo-white.svg`;
export const VIP_BG = `${imageCommonPath}/vip-colorwash-background.svg`;

export const VIP_INFO_BULLET = `${imageCommonPath}/vip-bullet-point.png`;

// Wowcher VIP HUB Exclusive
export const VIP_EXCLUSIVE_TAG = `${imageBrandPath}/vip-exclusive-badge.svg`;

// 2nd Checkout Progress Icons

// 2nd checkout progress icons - new

export const ORDER_CONFIRMED_ACTIVE_ICON = `${imageCommonPath}/filled-green-tick-icon.png`;

export const ORDER_CONFIRMED_STEP_ICON = `${imageCommonPath}/filled-green-tick-icon.png`;

export const BENEFITS_ACTIVE_ICON = `${imageBrandPath}/outlined-plus-icon.svg`;

export const BENEFITS_STEP_ICON = `${imageCommonPath}/filled-green-plus-icon.png`;
export const DEALS_ACTIVE_ICON = `${imageBrandPath}/outlined-percentage-icon.svg`;

export const DEALS_STEP_ICON = `${imageCommonPath}/filled-green-percentage-icon.svg`;
export const REDEEM_VOUCHER_ACTIVE_ICON = `${imageBrandPath}/redeem-voucher-active-icon.svg`;

export const REDEEM_VOUCHER_STEP_ICON = `${imageBrandPath}/redeem-voucher-step-icon.svg`;

export const WHITE_BENEFITS = `${imageBrandPath}/add-icon-dull.svg`;

export const WHITE_DEALS = `${imageBrandPath}/percentage-icon-dull.svg`;

export const WHITE_REDEEM_VOUCHERS = `${imageBrandPath}/redeem-voucher-icon.svg`;

// 2nd Checkout Vouhcer Benefit Card Icons
export const CHAMPAGNE = `${imageCommonPath}/champagne-icon.svg`;
export const GREEN_TICK = `${imageCommonPath}/outlined-green-tick.svg`;
export const CLOCK = `${imageBrandPath}/clock.svg`;
export const SHIELD = `${imageBrandPath}/shield.svg`;
export const DISABLED_SHIELD = `${imageCommonPath}/shield-grey.svg`;

export const EXCLAMATION_CIRCLE_RED = `${imageCommonPath}/exclamation-circle-red.svg`;
// export const EXCLAMATION_CIRCLE_RED =
//   'https://resources.wowcher.co.uk/assets/img/ExclamationCircleRed.svg';

export const WOW =
  'https://resources.wowcher.co.uk/assets/img/brand/wowcher/Wowcher-Wow-Pink-Splat.svg';

// Map View Pins Icons
export const MAP_WIDGET_BG = `${imageCommonPath}/map-view-image-small.svg`;
// export const MAP_WIDGET_BG =
//   'http://resources.wowcher.co.uk/assets/img/brand/wowcher/map-view/Map+View+Small.svg';
export const MAP_MENU =
  'https://resources.wowcher.co.uk/assets/img/brand/wowcher/map-view/menu.svg';
export const MAP =
  'https://resources.wowcher.co.uk/assets/img/brand/wowcher/map-view/map.svg';
export const MAP_MARKER_OUTLINED =
  'https://resources.wowcher.co.uk/assets/img/brand/wowcher/map-view/map-marker.svg';
export const MAP_MARKER_FILLED =
  'http://resources.wowcher.co.uk/assets/img/brand/wowcher/map-view/map-marker-2.svg';

export const ACTIVITIES =
  'https://resources.wowcher.co.uk/assets/img/brand/wowcher/map-view/Map_+View_Activities.svg';
export const BEAUTY =
  'https://resources.wowcher.co.uk/assets/img/brand/wowcher/map-view/Map_View_Beauty.svg';
export const UK_CITY_BREAKS =
  'https://resources.wowcher.co.uk/assets/img/brand/wowcher/map-view/Map_View_UK-City-Breaks.svg';
export const SPORTS_ADVENTURE =
  'https://resources.wowcher.co.uk/assets/img/brand/wowcher/map-view/Map_View_Sports-Adventure.svg';
export const SPAS_COUNTRY_HOUSE =
  'https://resources.wowcher.co.uk/assets/img/brand/wowcher/map-view/Map_View_Spas-Country-House.svg';
export const RESTURANTS_BARS =
  'https://resources.wowcher.co.uk/assets/img/brand/wowcher/map-view/Map_View_Restaurants-Bars.svg';
export const FITNESS =
  'https://resources.wowcher.co.uk/assets/img/brand/wowcher/map-view/Map_View_Fitness.svg';
export const ENTERTAINMENT =
  'https://resources.wowcher.co.uk/assets/img/brand/wowcher/map-view/Map_View_Entertainment.svg';
export const UK_SEASIDE =
  'https://resources.wowcher.co.uk/assets/img/brand/wowcher/map-view/Map_View_UK-Seaside.svg';

export const GIFTING_DISCOUNT_IMAGE = `${imageBrandPath}/discount-cross.svg`;

export const GIFTING_GIFTPACK_IMAGE = `${imageBrandPath}/gift-pack-image.png`;

// };
export const GIFTING_DELIVERY_IMAGE = `${imageBrandPath}/delivery-truck.svg`;
export const GIFTING_LOCAL_IMAGE = `${imageBrandPath}/local-gift-pdf-image.svg`;

// Buy again variables
export const BUY_AGAIN_ICONS = {
  fivepm: 'https://resources.wowcher.co.uk/assets/img/Buy_Again_White.svg',
  wowcher:
    'https://s3.eu-west-1.amazonaws.com/resources.wowcher.co.uk/assets/img/Buy-Again.svg',
};

// Refer A Friend For Only Wowcher
export const RAF_BANNER =
  'https://resources.wowcher.co.uk/assets/img/brand/wowcher/refer-a-friend/raf_new_banner.png';
export const RAF_MOBILE_BANNER =
  'https://resources.wowcher.co.uk/assets/img/brand/wowcher/refer-a-friend/raf_mobile_banner.png';
export const RAF_DOTTED_BOX =
  'https://resources.wowcher.co.uk/assets/img/brand/wowcher/refer-a-friend/dotted_xbox.svg';
export const RAF_MONEY =
  'https://resources.wowcher.co.uk/assets/img/brand/wowcher/refer-a-friend/Money-01.svg';
export const RAF_PLANE =
  'https://resources.wowcher.co.uk/assets/img/brand/wowcher/refer-a-friend/Plane-01.svg';
export const REFEREE_WELCOME = `${imageBrandPath}/raf-referee-already-registered-banner.png`;
export const REFEREE_ALREADY_REGISTERED_BANNER = `${imageBrandPath}/raf-referee-welcome-banner.png`;

/* OLD IMAGE PATHS */
